<style lang="scss">
.ag-select-popper {
  .el-select-dropdown__item {
    height: auto !important;
  }
}

.el-link.el-link--primary {
  text-decoration: underline;
}
</style>
<style lang="scss" scoped>
$rt-padding: 20px;

.dialog-wrap {
  ::v-deep .el-form-item {
    width: 50%;
    margin: 0;
    float: left;
    margin-bottom: 10px;

    .el-form-item__content {
      padding-right: $rt-padding;
    }

    &.extension {
      width: 100%;
    }
  }

  .detail-wrap {
    float: left;
    margin-bottom: 20px;

    .title {
      padding-bottom: 6px;
      font-size: 12px;
      user-select: none;

      i.add-btn {
        &:hover {
          color: $color-primary;
        }

        &:active {
          opacity: 0.8;
        }
      }

      i.delete-btn {
        float: right;
        margin-right: $rt-padding + 2px;

        &:hover {
          color: $color-danger;
        }

        &:active {
          opacity: 0.8;
        }
      }

      i.iconfont {
        position: relative;
        cursor: pointer;
        font-size: 12px;
        line-height: 14px;
      }
    }

    .detail-content {
      background-color: $border-color-base;
      border-radius: 4px;
      box-sizing: border-box;
      padding: 20px 8px 20px 8px;
      margin-right: $rt-padding;
    }
  }

  .dialog-footer {
    text-align: right;
    padding-right: 20px;
    padding-bottom: 40px;
    padding-top: 20px;
  }
}
</style>
<style lang="scss" scoped>
.invoice-wrap {
  position: relative;
  padding-left: 82px;
  height: 100px;

  & ::v-deep {
    .avatar-uploader {
      width: 82px;
      position: absolute;
      left: 0;
      top: 0;
    }

    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      background-color: #fff;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 82px;
      height: 64px;
      line-height: 64px;
      text-align: center;
    }

    .avatar {
      width: 82px;
      height: 64px;
      font-size: 30px;
      line-height: 64px;
      color: #409eff;
      display: block;
    }
  }

  .invoice-error {
    position: absolute;
    left: 0;
    bottom: 0;

    span.text {
      vertical-align: middle;
      display: inline-block;
      line-height: 16px;
      color: $color-warning;

      i {
        margin-right: 2px;
      }
    }
  }

  .invoice-info {
    height: 64px;
    line-height: 64px;
    // color: $color-warning;
    padding-left: 12px;
    overflow: hidden;
    box-sizing: border-box;

    span.text {
      vertical-align: middle;
      display: inline-block;
      line-height: 16px;

      i {
        margin-right: 2px;
      }
    }
  }
}
</style>
<template>
  <el-dialog
    :title="this.operationType == 'create' ? '填写报销表单' : '修改报销表单'"
    v-loading="pageLoading"
    top="3vh"
    :visible.sync="dialogVisible"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :destroy-on-close="true"
    width="800px"
  >
    <div class="dialog-wrap">
      <el-form
        ref="formDataRef"
        :model="formData"
        label-width="80px"
        label-position="left"
        class="clearfix"
        size="medium"
      >
        <el-form-item prop="title	" label="报销标题">
          <el-input
            v-model="formData.title"
            placeholder="请填写报销标题"
          ></el-input>
        </el-form-item>
        <el-form-item prop="coin_type" label="选择币种">
          <el-select
            v-model="formData.coin_type"
            placeholder="请选择币种"
            :disabled="false"
            :collapse-tags="true"
            style="width: 100%;"
          >
            <el-option
              v-for="coinItem in coins"
              :label="coinItem.name"
              :key="coinItem.id"
              :value="coinItem.id"
            >
              {{ coinItem.name }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="owner_company_id" label="公司主体">
          <el-select
            v-model="formData.owner_company_id"
            placeholder="请选择公司主体"
            :collapse-tags="true"
            style="width: 100%;"
          >
            <el-option
              v-for="companyItem in companys"
              :label="companyItem.name"
              :key="companyItem.id"
              :value="companyItem.id"
            >
              {{ companyItem.name }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="real_user_open_id " label="实际报销人">
          <el-select
            v-model="formData.real_user_open_id"
            placeholder="请选择企业负责人"
            :collapse-tags="true"
            filterable
            style="width: 100%;"
          >
            <el-option
              v-for="user in responsibleUserList"
              :label="user.name"
              :key="user.open_id"
              :value="user.open_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="owner_project_id" label="选择项目">
          <el-select
            v-model="formData.owner_project_id"
            placeholder="请选择项目"
            :collapse-tags="true"
            style="width: 100%;"
          >
            <el-option
              v-for="projectItem in projects"
              :label="projectItem.name"
              :key="projectItem.id"
              :value="projectItem.id"
            >
              {{ projectItem.name }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传附件" class="extension">
          <template slot="label">
            上传附件
            <az-issue :tipW="200" text="仅支持jpg , jpeg, png, pdf"></az-issue>
          </template>
          <div class="invoice-wrap1">
            <el-upload
              ref="upload"
              drag
              class="avatar-uploader"
              :file-list="formData.img_keys"
              accept=".jpg,.jpeg,.png,.pdf"
              :action="`/api/base/upload?az_tk=${token}`"
              :on-remove="handleRemoveAccessory"
              :on-exceed="handleExceedAccessory"
              :limit="5"
              :on-success="
                (res, file, fileList) =>
                  handleAvatarSuccessAccessory(res, file, fileList)
              "
              :before-upload="(file) => beforeAvatarUploadAccessory(file)"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>
        <div
          :key="index"
          class="detail-wrap"
          v-for="(detailItem, index) in formData.detail"
        >
          <div class="title">
            明细{{ index + 1 }}
            <i
              @click="addDetailHandler(index)"
              class="add-btn iconfont oaicon-create"
            ></i>
            <i
              @click="deleteDetailHandler(index)"
              class="delete-btn iconfont oaicon-shanchu"
            ></i>
          </div>
          <div class="detail-content clearfix">
            <el-form-item label="报销类型">
              <el-select
                v-model="detailItem.type"
                placeholder="选择报销类型"
                popper-class="ag-select-popper"
                :collapse-tags="true"
                style="width: 100%;"
              >
                <el-option
                  v-for="expenseTypeItem in expenseTypes"
                  :label="expenseTypeItem.name"
                  :key="expenseTypeItem.id"
                  :value="expenseTypeItem.id"
                >
                  <div style="padding: 5px 0;">
                    <span>{{ expenseTypeItem.name }}</span>
                    <div style="line-height: 18px; color: #aaa;">
                      {{ expenseTypeItem.remark }}
                    </div>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="明细金额">
              <el-input-number
                style="width: 100%;"
                v-model="detailItem.money"
                :precision="2"
                :step="1"
                :min="0"
                :max="999999999"
                @blur="moneyChangeHandler(detailItem.money, detailItem)"
              >
              </el-input-number>
            </el-form-item>
            <el-form-item label="日期">
              <el-date-picker
                style="width: 100%;"
                v-model="detailItem.created_at"
                format="yyyy 年 MM 月 dd 日 HH 时 mm 分 ss 秒"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="备注信息">
              <el-input
                v-model="detailItem.remark"
                placeholder="请填写备注"
              ></el-input>
            </el-form-item>
            <el-form-item label="发票类型">
              <el-select
                v-model="detailItem.invoice_type"
                placeholder="选择发票类型"
                popper-class="ag-select-popper"
                @change="(val) => selectReimbursementType(val, index)"
                :collapse-tags="true"
                style="width: 100%;"
              >
                <el-option
                  v-for="(value, name) in invoiceRes"
                  :label="value"
                  :key="name"
                  :value="name"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="税额">
              <el-input-number
                style="width: 100%;"
                v-model="detailItem.sum_tax_amount"
                :precision="2"
                :step="1"
                :min="0"
                :max="999999999"
                @blur="
                  taxAmountChangeHandler(detailItem.sum_tax_amount, detailItem)
                "
              >
              </el-input-number>
            </el-form-item>
            <el-form-item label="上传发票" class="extension">
              <template slot="label">
                上传发票
                <az-issue
                  :tipW="200"
                  text="仅支持jpg , jpeg, png, pdf"
                ></az-issue>
              </template>
              <div class="invoice-wrap">
                <el-upload
                  :ref="'upload' + index"
                  class="avatar-uploader"
                  :action="`/api/base/upload?az_tk=${token}`"
                  accept=".jpg,.jpeg,.png,.pdf"
                  :show-file-list="false"
                  :on-success="
                    (res, file) => handleAvatarSuccess(res, file, index)
                  "
                  :on-error="(err, file) => handleOnError(err, file, index)"
                  :data="{ type: detailItem.invoice_type }"
                  :before-upload="(file) => beforeAvatarUpload(file, index)"
                >
                  <!-- <img v-if="detailItem.key"
                    src="../../../../assets/image/upload-success.svg" class="avatar"> -->
                  <i v-if="detailItem.key" class="avatar el-icon-success"></i>
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <div class="invoice-info">
                  <span class="text">
                    <a
                      v-if="detailItem.uploadLoading"
                      style="color: #2f78ff;"
                      :href="`/api/base/download?key=${detailItem.key}`"
                      target="_blank"
                      >{{ detailItem.filename }}</a
                    >
                    <i class="el-icon-loading" v-else></i>
                  </span>
                </div>
                <div class="invoice-error">
                  <span class="text" v-if="detailItem.error_msg"
                    ><i class="el-icon-warning"></i
                    >{{ detailItem.error_msg }}</span
                  >
                </div>
              </div>
            </el-form-item>
          </div>
        </div>
        <el-form-item
          prop="sum_money"
          label="总金额"
          :rules="{
            required: true,
            message: '总金额不能为空',
            trigger: 'blur',
          }"
        >
          <span>{{ sumMoney }}</span> 元
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-popconfirm
          confirm-button-text="确定"
          cancel-button-text="取消"
          icon="el-icon-info"
          icon-color="red"
          @confirm="submitHandler"
          title="已检查各项信息填写无误，确认提交？"
        >
          <el-button
            slot="reference"
            size="small"
            type="primary"
            :loading="btnIsLoading"
          >
            保存并提交
          </el-button>
        </el-popconfirm>
        <el-button
          slot="reference"
          size="small"
          @click="dialogVisible = false"
          style="margin-left: 10px;"
          >取 消
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
// getExpenseTypeList
// import pdf from 'vue-pdf'
import { coins, approvalInstanceType } from '@/const';
import {
  createApprovalInstance,
  getExpenseTypeList,
  getInvoiceTypeList,
  modifyOriginalFrom,
} from '@/api/approval';
import { getUsers } from '@/api/user';
import { getCompanyList } from '@/api/company';
import { getProjects } from '@/api/project';
import azIssue from '@/base/azIssue.vue';

export default {
  name: 'approval-instance-form',
  watch: {
    'formData.owner_company_id': function (val, oldVal) {
      if (oldVal) {
        // this.$message.warning('公司主体已改变，请确定已上传发票信息是否匹配');
        const companyMain = this.companys.filter((item) => {
          return item.id == val;
        });
        if (companyMain.length <= 0) return;
        console.log(val, 'val');
        console.log(this.formData, 'this.formData');
        this.formData.detail.forEach((item) => {
          if (!item.buyer_name && !item.buyer_id) {
            item.error_msg = '';
          } else if (
            this.dealCnAndEn(item.buyer_name) ===
              this.dealCnAndEn(companyMain[0].name) &&
            item.buyer_id === companyMain[0].tax_id
          ) {
            item.error_msg = item.error_msg && '';
          } else if (
            this.dealCnAndEn(item.buyer_name) !=
              this.dealCnAndEn(companyMain[0].name) &&
            item.buyer_id === companyMain[0].tax_id
          ) {
            item.error_msg = '上传发票与所选公司主体下的企业名称不一致';
          } else if (
            this.dealCnAndEn(item.buyer_name) ===
              this.dealCnAndEn(companyMain[0].name) &&
            item.buyer_id != companyMain[0].tax_id
          ) {
            item.error_msg = '上传发票与所选公司主体下的企业税号不一致';
          } else {
            item.error_msg = '上传发票与所选公司主体不一致';
          }
        });
      }
    },
  },
  components: {
    azIssue,
  },
  data() {
    return {
      operationType: 'create',
      uploadLoading: true,
      imageUrl: '',
      basic_type: '',
      task_id: '',
      dialogVisible: false,
      pageLoading: false,
      expenseTypes: [],
      invoiceRes: [],
      btnIsLoading: false,
      companys: [],
      projects: [],
      responsibleUserList: [],
      popconfirmSubmit: true,
      coins: coins,
      filename: '',
      formData: {
        // 初始赋值，防止computed中sumMoney生成报错
        title: '',
        coin_type: 1,
        sum_money: 0,
        owner_project_id: '',
        owner_company_id: '',
        img_keys: [],
        real_user_open_id: this.$store.state.user.open_id,
        detail: [
          {
            type: '',
            money: '',
            created_at: '',
            remark: '',
            invoice_type: null,
            uploadLoading: true,
            invoice_money: '', // 发票金额
          },
        ],
      },
    };
  },
  computed: {
    typeName() {
      const idMap = approvalInstanceType.constMap.idMap[this.basic_type];
      console.log('idMap', idMap);
      return idMap && idMap.name;
    },
    token() {
      return this.$store.getters.token;
    },
    sumMoney() {
      let money = 0;
      // this.formData.detail.forEach(item => {
      //   const integerNum = item.money
      //   money += integerNum
      // })
      // return money
      this.formData.detail.forEach((item) => {
        // FIXME: 1
        const integerNum = Math.floor(item.money * 1000);
        console.log('integerNum', integerNum);
        money += integerNum;
      });
      console.log('money', money);
      return `${money / 1000}`;
    },
  },
  mounted() {
    this.$on('open', (basic_type) => {
      this.operationType = 'create';
      console.log(basic_type, 'basic_type');
      this.basic_type = basic_type;
      this.dialogVisible = true;
      this.formData = {
        title: '',
        coin_type: 1,
        sum_money: 0,
        owner_project_id: '',
        owner_company_id: '',
        real_user_open_id: this.$store.state.user.open_id,
        img_keys:[],
        detail: [
          {
            type: '',
            money: '',
            created_at: '',
            remark: '',
            invoice_type: null,
            uploadLoading: true,
            sum_tax_amount: '', // 发票税额
          },
        ],
      };
      this.initPage();
    });
    this.$on('edit', (task_id, data) => {
      this.operationType = 'edit';
      const {
        title,
        coin_type,
        sum_money,
        owner_project_id,
        remark,
        owner_company_id,
        detail,
        real_user_open_id,
        img_keys,
      } = data;
      this.task_id = task_id;
      this.dialogVisible = true;
      this.formData = {
        title,
        remark,
        coin_type,
        sum_money,
        owner_project_id,
        owner_company_id,
        real_user_open_id,
        detail,
        img_keys: img_keys || [],
      };
      this.initPage();
    });
  },
  methods: {
    handleRemoveAccessory(file, fileList) {
      console.log(file, fileList);
      this.formData.img_keys = fileList;
    },
    handleExceedAccessory(files, fileList) {
      this.$message({
        message: '同时最多只能上传5个文件',
        type: 'error',
      });
    },
    handleAvatarSuccessAccessory(res, file, fileList) {
      if (res.code != 0 || !res.data) {
        this.$message.error('上传失败');
      } else {
        // this.formData.img_keys = fileList;
        this.formData.img_keys.push({ name: file.name, key: res.data.key });
        console.log(this.formData.img_keys,'shag')
        this.$message({
          message: '上传成功',
          type: 'success',
        });
      }
    },
    beforeAvatarUploadAccessory(file) {
      console.log(file);
      console.log(this.fileList, 'fileList');
      let isImg = true;
      if (file.name) {
        const names = file.name.split('.');
        isImg = ['png', 'jpg', 'jpeg', 'pdf'].includes(names[names.length - 1]);
      }
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isImg) {
        this.$message.error('请上传png, jpg, jpeg, pdf类型的文件');
        return false;
      }
      // 判断上传文件格式是否正确
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 20MB!');
        return false;
      }
      return true;
    },
    selectReimbursementType(val, index) {
      this.$refs[`upload${index}`][0].clearFiles();
      delete this.formData.detail[index].key;
      delete this.formData.detail[index].filename;
      delete this.formData.detail[index].error_msg;
    },
    dealCnAndEn(str) {
      return str.replace(/\(/g, '（').replace(/\)/g, '）');
    },
    handleAvatarSuccess(res, file, index) {
      if (res.code != 0 || !res.data) {
        this.$message.error('上传失败');
        this.formData.detail[index].uploadLoading = true;
      } else {
        // console.log(res.data.ocr.code, res.data.ocr.message, 'fdfd')
        this.formData.detail[index].key = res.data.key;
        this.formData.detail[index].filename = file.name;
        if (res.data.ocr.code == 0 && res.data.ocr.message) {
          this.formData.detail[index].uploadLoading = true;
          this.formData.detail[index].error_msg =
            '发票识别失败，重新上传或人工审核';
          return;
        }
        if (res.data.explain_ocr) {
          if (res.data.explain_ocr.sum_amount) {
            // 合计金额
            this.formData.detail[index].money = res.data.explain_ocr.sum_amount;
          }

          if (
            res.data.explain_ocr.sum_tax_amount == 0 ||
            res.data.explain_ocr.sum_tax_amount
          ) {
            // 合计税额
            this.formData.detail[index].sum_tax_amount =
              res.data.explain_ocr.sum_tax_amount;
          }
        }
        if (
          res.data.explain_ocr &&
          res.data.explain_ocr.buyer_name &&
          res.data.explain_ocr.buyer_id
        ) {
          // TODO: 判断主体和税号
          this.formData.detail[index].buyer_name =
            res.data.explain_ocr.buyer_name;
          this.formData.detail[index].buyer_id = res.data.explain_ocr.buyer_id;
          const companyMain = this.companys.filter((item) => {
            return item.id == this.formData.owner_company_id;
          });
          // 将公司主体企业名称和发票识别的公司名称中的括号都替换成中文括号
          const explain_ocr = res.data.explain_ocr;
          // 获取选中公司主体，通过上传成功res中的主体和税号判断是否正确
          if (
            this.dealCnAndEn(companyMain[0].name) ==
              this.dealCnAndEn(explain_ocr.buyer_name) &&
            companyMain[0].tax_id == explain_ocr.buyer_id
          ) {
            this.$message({
              message: '上传成功',
              type: 'success',
            });
            this.formData.detail[index].error_msg =
              this.formData.detail[index].error_msg && '';
          } else if (
            this.dealCnAndEn(companyMain[0].name) !=
              this.dealCnAndEn(explain_ocr.buyer_name) &&
            companyMain[0].tax_id == explain_ocr.buyer_id
          ) {
            this.formData.detail[index].error_msg =
              '上传发票与所选公司主体下的企业名称不一致';
          } else if (
            this.dealCnAndEn(companyMain[0].name) ==
              this.dealCnAndEn(explain_ocr.buyer_name) &&
            companyMain[0].tax_id != explain_ocr.buyer_id
          ) {
            this.formData.detail[index].error_msg =
              '上传发票与所选公司主体下的企业税号不一致';
          } else {
            this.formData.detail[index].error_msg =
              '上传发票与所选公司主体不一致';
          }
        } else {
          this.$message({
            message: '上传成功',
            type: 'success',
          });
        }
        this.formData.detail[index].uploadLoading = true;
      }
    },
    handleOnError(err, file, index) {
      console.log(1111111111111111);
      console.log('err');
      this.formData.detail[index].uploadLoading = true;
      this.formData.detail[index].error_msg =
        '发票识别失败，重新上传或人工审核';
    },
    beforeAvatarUpload(file, index) {
      // 公司主体，项目， 发票类型，文件格式、大小验证
      const isChooseInvoicetype = !!this.formData.detail[index].invoice_type;
      const owner_company_id = !!this.formData.owner_company_id;
      let isImg = true;
      if (file.name) {
        const names = file.name.split('.');
        isImg = ['png', 'jpg', 'jpeg', 'pdf'].includes(names[names.length - 1]);
      }
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!owner_company_id) {
        this.$message.error('请先选择公司主体');
        return false;
      }
      //  判断发票类型是否选择
      if (!isChooseInvoicetype) {
        this.$message.error('请先选择发票类型');
        return false;
      }
      // 判断上传发票格式是否符合
      if (!isImg) {
        this.$message.error('请上传png, jpg, jpeg, pdf类型的文件');
        return false;
      }
      // 判断上传文件格式是否正确
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 20MB!');
        return false;
      }
      this.formData.detail[index].uploadLoading = false;
      // this.uploadLoading = false;
      return true;
      // return isImg && isLt2M && isChooseInvoicetype;
    },
    moneyChangeHandler(moeny, item) {
      console.log('moeny', moeny);
      if (typeof moeny !== 'number') {
        item.money = 0;
      }
    },
    taxAmountChangeHandler(moeny, item) {
      console.log('moeny', moeny);
      if (typeof moeny !== 'number') {
        item.sum_tax_amount = 0;
      }
    },
    addDetailHandler(index) {
      this.formData.detail.splice(index + 1, 0, {
        type: '',
        money: '',
        sum_tax_amount: '',
        created_at: '',
        remark: '',
        uploadLoading: true,
      });
    },
    deleteDetailHandler(index) {
      if (this.formData.detail.length <= 1) {
        return this.$message({
          message: '请至少保留一条报销明细',
          type: 'warning',
        });
      }
      this.formData.detail.splice(index, 1);
    },
    createApprovalInstanceHandler() {
      this.btnIsLoading = true;
      this.formData.sum_money = this.sumMoney;
      createApprovalInstance(this.basic_type, this.formData)
        .then((res) => {
          console.log('res', res);
          if (res.code != 0) throw new Error(res.message);
          this.$message.success('保存成功');
          this.dialogVisible = false;
          this.$emit('refresh');
        })
        .catch((err) => {
          this.$message.error(err.message);
        })
        .finally(() => {
          this.btnIsLoading = false;
          this.popconfirmSubmit = true;
        });
    },
    editApprovalInstanceHandler() {
      this.btnIsLoading = true;
      this.formData.sum_money = this.sumMoney;
      modifyOriginalFrom(this.task_id, this.formData)
        .then((res) => {
          console.log('res', res);
          if (res.code != 0) throw new Error(res.message);
          this.$message.success('保存成功');
          this.dialogVisible = false;
          this.$emit('refresh');
        })
        .catch((err) => {
          this.$message.error(err.message);
        })
        .finally(() => {
          this.btnIsLoading = false;
          this.popconfirmSubmit = true;
        });
    },
    submitHandler() {
      if (!this.formData.title) {
        return this.$message.warning('请填写报销标题');
      }
      if (!this.formData.owner_company_id) {
        return this.$message.warning('请选择公司主体');
      }
      if (!this.formData.owner_project_id) {
        return this.$message.warning('请选择项目');
      }
      for (let i = 0; i < this.formData.detail.length; i++) {
        if (!this.formData.detail[i].key) {
          return this.$message.warning('请查看明细列表中发票是否上传完整');
        }
      }
      if (!this.popconfirmSubmit) return;
      this.popconfirmSubmit = false;
      this[`${this.operationType}ApprovalInstanceHandler`]();
    },
    async initPage() {
      this.pageLoading = true;
      const [companyRes, customerRes, expenseRes, invoiceRes, userRes] =
        await Promise.all([
          getCompanyList({ status: 2, page: 1, per_page: 1000, type: 1 }),
          getProjects({ page: 1, per_page: 20000 }),
          getExpenseTypeList({ page: 1, per_page: 20000 }),
          getInvoiceTypeList({ page: 1, per_page: 20000 }),
          getUsers(),
        ]);
      if (
        companyRes.code === 0 &&
        companyRes.data &&
        Array.isArray(companyRes.data.items)
      ) this.companys = companyRes.data.items;
      if (
        customerRes.code === 0 &&
        customerRes.data &&
        Array.isArray(customerRes.data.items)
      ) this.projects = customerRes.data.items;
      if (
        expenseRes.code === 0 &&
        expenseRes.data &&
        Array.isArray(expenseRes.data.items)
      ) this.expenseTypes = expenseRes.data.items;
      if (invoiceRes.code === 0 && invoiceRes.data) this.invoiceRes = invoiceRes.data;
      if (userRes.code === 0 && userRes.data) this.responsibleUserList = userRes.data;
      this.pageLoading = false;
    },
  },
};
</script>
